import React from 'react'
import AdminViewTrainerAtd from '../../features/admin/AdminViewTrainerAtd'

const AdminViewTrainerAtdPage = () => {
  return <AdminViewTrainerAtd />
}

export default AdminViewTrainerAtdPage